export default `
  query getInvoices($startingAfter: String, $limit: Int, $customerId: String,) {
    getInvoices(startingAfter: $startingAfter, limit: $limit, customerId: $customerId,) {
      success
      message
      invoices {
        id
        amountDue
        hostedInvoiceUrl
        invoicePdf
        status
        createdAt
        lines {
          data {
            description
          }
        }
      }
    }
  }
`
